"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKDataGridLegacyPromiseExampleCodeSegments = exports.GKDataGridLegacyPromiseExample = void 0;
var gds_ux_components_1 = require("@granular/gds-ux-components");
var React = __importStar(require("react"));
var __1 = require("../..");
var loadingStates = [
    { name: "undefined (data-driven)" },
    { name: "isLoading = true", loading: true },
    { name: "isLoading = false", loading: false },
];
var cropBits = ["Corn", "Soybeans", "Wheat", "Potatoes", "Sorghum", "Cotton"];
var nameBits = [
    "Lorem",
    "Ipsum",
    "Dolor",
    "Sit",
    "Amet",
    "Consecteur",
    "Adipiscing",
    "Elit",
    "Sed",
];
var ceil = Math.ceil, floor = Math.floor, random = Math.random;
// Generates an array of 10 new IData objects
var generateNewData = function () {
    return __spreadArray([], Array(10), true).map(function (d, i) { return ({
        // 40 - 400 acre fields
        acres: floor(random() * 360 + 40),
        // Crop chosen at random from cropBits
        crop: cropBits[floor(random() * cropBits.length)],
        id: i,
        // 2 - 4 words chosen at random from nameBits
        name: __spreadArray([], Array(ceil(random() * 3 + 1)), true).map(function () { return nameBits[floor(random() * nameBits.length)]; })
            .join(" "),
    }); });
};
// Returns a Promise that resolves in 3 seconds
var getDataPromise = function () {
    return new Promise(function (resolve) {
        window.setTimeout(function () { return resolve(generateNewData()); }, 3000);
    });
};
var GKDataGridLegacyPromiseExample = function () {
    var _a = React.useState(getDataPromise()), myData = _a[0], setMyData = _a[1];
    var _b = React.useState(), loadingState = _b[0], setLoadingState = _b[1];
    return (React.createElement(gds_ux_components_1.Row, null,
        React.createElement(gds_ux_components_1.Col, { sm: 3 },
            React.createElement(gds_ux_components_1.GKFormGroup, null,
                React.createElement(gds_ux_components_1.GKButton, { onClick: function () { return setMyData(getDataPromise()); } }, "Get New Data")),
            React.createElement(gds_ux_components_1.GKFormGroup, null,
                React.createElement(gds_ux_components_1.GKLabel, { for: "loading-states" }, "isLoading Prop Status"),
                React.createElement(gds_ux_components_1.GKSelect, { id: "loading-states", data: loadingStates, itemToString: function (i) { return i.name; }, onChange: function (i) { return setLoadingState(i.loading); }, selectedItem: loadingStates[0] }))),
        React.createElement(gds_ux_components_1.Col, { sm: 9 },
            React.createElement(__1.GKDataGridLegacy, { columns: [
                    {
                        Header: "Field",
                        accessor: "name",
                    },
                    {
                        Header: "Acres",
                        accessor: "acres",
                    },
                    {
                        Header: "Crop",
                        accessor: "crop",
                    },
                ], data: myData, expandable: true, onSelection: function () { return null; }, gridStyle: { height: 300 }, isLoading: loadingState, SubComponent: function (row) { return (React.createElement("p", { className: "m-2 p-2 border" },
                    "Detail about ",
                    row.original.name,
                    " goes here.")); } }))));
};
exports.GKDataGridLegacyPromiseExample = GKDataGridLegacyPromiseExample;
// </copy>
// AUTOGENERATED:
/* eslint-disable prettier/prettier */
exports.GKDataGridLegacyPromiseExampleCodeSegments = ["interface IData {\n  id: number;\n  name: string;\n  acres: number;\n  crop: string;\n}\ninterface ILoadingState {\n  name: string;\n  loading?: boolean;\n}\nconst loadingStates: ILoadingState[] = [\n  { name: \"undefined (data-driven)\" },\n  { name: \"isLoading = true\", loading: true },\n  { name: \"isLoading = false\", loading: false },\n];\nconst cropBits = [\"Corn\", \"Soybeans\", \"Wheat\", \"Potatoes\", \"Sorghum\", \"Cotton\"];\nconst nameBits = [\n  \"Lorem\",\n  \"Ipsum\",\n  \"Dolor\",\n  \"Sit\",\n  \"Amet\",\n  \"Consecteur\",\n  \"Adipiscing\",\n  \"Elit\",\n  \"Sed\",\n];\nconst { ceil, floor, random } = Math;\n// Generates an array of 10 new IData objects\nconst generateNewData = (): IData[] =>\n  [...Array(10)].map((d, i) => ({\n    // 40 - 400 acre fields\n    acres: floor(random() * 360 + 40),\n    // Crop chosen at random from cropBits\n    crop: cropBits[floor(random() * cropBits.length)],\n    id: i,\n    // 2 - 4 words chosen at random from nameBits\n    name: [...Array(ceil(random() * 3 + 1))]\n      .map(() => nameBits[floor(random() * nameBits.length)])\n      .join(\" \"),\n  }));\n// Returns a Promise that resolves in 3 seconds\nconst getDataPromise = (): Promise<IData[]> =>\n  new Promise<IData[]>((resolve) => {\n    window.setTimeout(() => resolve(generateNewData()), 3000);\n  });\nexport const GKDataGridLegacyPromiseExample: React.FC = () => {\n  const [myData, setMyData] = React.useState<Promise<IData[]>>(\n    getDataPromise()\n  );\n  const [loadingState, setLoadingState] = React.useState<boolean>();\n  return (\n    <Row>\n      <Col sm={3}>\n        <GKFormGroup>\n          <GKButton onClick={(): void => setMyData(getDataPromise())}>\n            Get New Data\n          </GKButton>\n        </GKFormGroup>\n        <GKFormGroup>\n          <GKLabel for=\"loading-states\">isLoading Prop Status</GKLabel>\n          <GKSelect\n            id=\"loading-states\"\n            data={loadingStates}\n            itemToString={(i: ILoadingState): string => i.name}\n            onChange={(i: ILoadingState): void => setLoadingState(i.loading)}\n            selectedItem={loadingStates[0]}\n          />\n        </GKFormGroup>\n      </Col>\n      <Col sm={9}>\n        <GKDataGridLegacy\n          columns={[\n            {\n              Header: \"Field\",\n              accessor: \"name\",\n            },\n            {\n              Header: \"Acres\",\n              accessor: \"acres\",\n            },\n            {\n              Header: \"Crop\",\n              accessor: \"crop\",\n            },\n          ]}\n          data={myData}\n          expandable={true}\n          onSelection={(): null => null}\n          gridStyle={{ height: 300 }}\n          isLoading={loadingState}\n          SubComponent={(row: RowInfo): JSX.Element => (\n            <p className=\"m-2 p-2 border\">\n              Detail about {row.original.name} goes here.\n            </p>\n          )}\n        />\n      </Col>\n    </Row>\n  );\n};"];
/* eslint-enable prettier/prettier */
